//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import blok from '~/mixins/blok'
export default {
  mixins: [blok],
  computed: {
    image () {
      return this.$sb.parseImage(this.blok.image)
    },
    titleClass () {
      const classes = []

      if (this.blok.theme === 'white') {
        classes.push('tw-text-gray-800')
      } else {
        classes.push('tw-text-blue-700')
      }

      if (this.blok.title_size === 'small') {
        classes.push('md:tw-text-4xl')
      } else {
        classes.push('md:tw-text-5xl')
      }

      return classes
    },
    subtitleClass () {
      if (this.blok.theme === 'white') {
        return 'tw-text-gray-600'
      }

      return 'tw-text-blue-600'
    },
    containerClass () {
      if (this.blok.theme === 'white') {
        return 'tw-bg-white'
      }

      return 'tw-bg-blue-50'
    }
  }
}
